import React from 'react'
import UnauthorizedCard from 'src/components/UnauthorizedCard'
import { pushGtmDataLayer } from 'src/utils/gtm'

export default function UnauthorizedPage() {
    pushGtmDataLayer({
        event: 'UnauthorizedPage',
    })
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    return (
        <div className={'error-page'}>
            <UnauthorizedCard />
        </div>
    )
}
